import { Typography } from '@mui/material'
import React, { useState } from 'react'
import DialogConfirmCancel from '../../../../dialog/DialogConfirm'
import isEmpty from 'lodash/isEmpty'
import { validate } from '../../../../../utils'
import { Alert } from '@mui/material'
import InputField from '../../../../FormControl/input/InputField'
import useGrowthGoals from '../../../../../hooks/developmental-rubrics/useGrowthGoals'
import { useParams } from 'react-router-dom'

const DialogGrowthGoals = ({ onClose, open, formData, onSave, type }) => {
  const { id } = useParams()
  const types = ['create', 'edit', 'delete']
  const [form, setForm] = useState(formData);
  const [errors, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const {
    createGrowthGoals,
    updateGrowthGoals,
    deleteGrowthGoals
  } = useGrowthGoals();

  const onChange = (key, value) => {
    setForm({ ...form, [key]: value })
    setError({ ...errors, [key]: null })
  }

  const onConfirm = async (e) => {
    e.preventDefault();
    if (!types.includes(type)) {
      setError({ message: 'Invalid type' })
      return
    }
    const fieldRules = {
      question: 'required'
    }
    const errors = validate(fieldRules, form)
    if (!isEmpty(errors) && type !== 'delete') {
      setError(errors)
    } else {
      if (id) {
        setLoading(true)
        try {
          let result = { error: false } 
          if (type === 'create') {
            result = await createGrowthGoals(form)
          }
          if (type === 'edit') {
            result = await updateGrowthGoals(form._id, form)
          }
          if (type === 'delete') {
            result = await deleteGrowthGoals(form._id)
          }
          
          if (result.error) {
            setError(result)
          } else {
            onClose()
          }
        } catch (error) {
          const message = handlerErrorV2(error)
          setError({ message })
        } finally {
          setLoading(false)
        }
        setError({ message: 'Invalid id' })
      } else {
        onSave(form, type)
        onClose()
      }
    }
  }
  
  return (
    <DialogConfirmCancel
      id='add-growth-goals'
      open={open}
      onCancel={onClose}
      onConfirm={onConfirm}
      textConfirm={type === 'delete' ?  'Confirm' : 'Save'}
      title={`${type} question`}
      onCloseHeader={true}
      maxWidth='xs'
    >
      { type === 'delete'
        ? <Typography>Are you sure you want to delete the question?</Typography>
        : <div className='flex flex-col gap-4 py-4'>
          <div className='grid grid-cols-4 items-start gap-4'>
            <Typography variant='inherit' className='font-bold' color='primary' align='right' component='p'>
              Question
            </Typography>
            <div className='col-span-3'>
              <InputField
                id='question'
                name='question'
                value={form.question}
                error={errors?.question}
                helperText={errors?.question}
                onChange={(e) => onChange("question", e.target.value)}
                fullWidth
                multiline={true}
              />
            </div>
          </div>
        </div>
      }
      { errors && errors.message && 
        <Alert
          severity="error"
          onClose={() => setInputErrors({ message: null })}
        >
          {errors.message}
        </Alert> 
      }
    </DialogConfirmCancel>
  )
}

export default DialogGrowthGoals